import ExpiredCard from './ExpiredCard';
import enhance from '../UpdateCustomerInfo/containers/UpdateCustomerInfoContainer';

export default enhance(ExpiredCard);



// WEBPACK FOOTER //
// ./src/app/membership/ExpiredCard/index.js